import { TimesheetLabel } from '../../timesheet-labels/labelSchema';
import { isLabelValueEmpty } from '../../timesheet-labels/hooks';

export const shouldAcceptSuggestion = (
  label: TimesheetLabel,
  isEmptyLabelsEnabled: boolean
) => {
  return (
    isLabelValueEmpty(label.value) &&
    (isEmptyLabelsEnabled ? !label.acceptedBy : true)
  );
};
